import { Controller } from "react-hook-form";
import { Input } from "@/app/admin/_common/ui/input";
import { Label } from "@/app/admin/_common/ui/label";
import { Skeleton } from "@/app/admin/_common/ui/skeleton";
import TemplatePickerCard from "../TemplatePickerCard";
import type { EmailTemplate } from "./useEmailFormFlow";
import { Search } from "lucide-react";

export function EmailForm({
  control,
  errors,
  templates,
  templatesLoading,
  templateSearch,
  setTemplateSearch,
  selectedTemplateId,
  selectTemplate,
}: {
  control: any;
  errors: any;
  templates: EmailTemplate[];
  templatesLoading: boolean;
  templateSearch: string;
  setTemplateSearch: (value: string) => void;
  selectedTemplateId: string | null | undefined;
  selectTemplate: (id: string | null) => void;
}) {
  return (
    <div className="flex flex-col gap-4">
      <div className="grid gap-3">
        <Label htmlFor="name">Email name</Label>
        <Controller
          name="name"
          control={control}
          render={({ field }) => (
            <Input
              id="name"
              {...field}
              value={field.value ?? ""}
              placeholder="Kalshi show reminder"
            />
          )}
        />
        {errors.name && (
          <span className="text-[12px] text-red-600">{errors.name?.message}</span>
        )}
      </div>

      <div className="grid gap-3">
        <Label htmlFor="subject">Subject line</Label>
        <Controller
          name="subject"
          control={control}
          render={({ field }) => (
            <Input
              id="subject"
              {...field}
              value={field.value ?? ""}
              placeholder="Come laugh with us tomorrow"
            />
          )}
        />
        {errors.subject && (
          <span className="text-[12px] text-red-600">{errors.subject?.message}</span>
        )}
      </div>

      <div className="grid gap-3">
        <Label htmlFor="template-search">Template</Label>
        <div className="relative max-w-[420px]">
          <div className="pointer-events-none absolute inset-y-0 left-3 flex items-center">
            <Search className="size-3.5 text-muted-foreground" />
          </div>
          <Input
            id="template-search"
            type="search"
            placeholder="Search templates…"
            value={templateSearch}
            onChange={(e) => setTemplateSearch(e.target.value)}
            className="pl-9"
          />
        </div>

        {templatesLoading ? (
          <div className="flex flex-wrap gap-3">
            {Array.from({ length: 6 }).map((_, i) => (
              <Skeleton key={i} className="h-[180px] w-[140px] flex-none rounded-md" />
            ))}
          </div>
        ) : (
          <div className="flex max-h-[340px] flex-wrap gap-3 overflow-y-auto py-0.5">
            <TemplatePickerCard
              blank
              title="Start blank"
              selected={!selectedTemplateId}
              onClick={() => selectTemplate(null)}
            />
            {templates.map((template) => (
              <TemplatePickerCard
                key={template.id}
                title={template.title}
                thumbnail={template.thumbnail}
                isSample={template.is_sample}
                selected={selectedTemplateId === template.id}
                onClick={() => selectTemplate(template.id)}
              />
            ))}
            {templates.length === 0 && (
              <p className="py-1 text-[12.5px] text-muted-foreground">
                No templates match your search.
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
